var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "E76CF35B-A1D7-433B-B721-B2B06483979F")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(-771.000000, -418.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(732.000000, 418.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2798867,20 L43.9949008,20 L43.9949008,6.50388098 L39.2798867,6.50388098 L39.2798867,20 Z M41.6685552,0 C40.0560907,0 39,1.00689953 39,2.33074601 C39,3.62656317 40.0254958,4.66364812 41.6062323,4.66364812 L41.6379603,4.66364812 C43.2832861,4.66364812 44.3053824,3.62656317 44.3053824,2.33074601 C44.2747875,1.00689953 43.2832861,0 41.6685552,0 L41.6685552,0 Z M61,12.2617508 L61,20 L56.2849858,20 L56.2849858,12.7802932 C56.2849858,10.9670116 55.6028329,9.72833118 53.8963173,9.72833118 C52.5932011,9.72833118 51.8181303,10.5638206 51.4759207,11.3702027 C51.3524079,11.6580423 51.3206799,12.0590772 51.3206799,12.4633463 L51.3206799,20 L46.6033994,20 C46.6033994,20 46.6668555,7.77274687 46.6033994,6.50495903 L51.3195467,6.50495903 L51.3195467,8.4174213 C51.3104816,8.43251401 51.298017,8.44760673 51.2889518,8.46162139 L51.3195467,8.46162139 L51.3195467,8.4174213 C51.9461756,7.5 53.0657224,6.18801207 55.5699717,6.18801207 C58.6736544,6.18801207 61,8.11664511 61,12.2617508 L61,12.2617508 Z",
    id: "Linked-in-white"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.058b4ce7.svg";
export { ForwardRef as ReactComponent };